import React, { Component, Fragment } from "react";
import { isMobile } from "mobile-device-detect";

import Fuzz from "fuzzball";

import Cookies from "react-cookies";

import Modal from "react-bootstrap/Modal";

import UBXButton from "./../ubx/button";
import UBXFormGroup from "./../ubx/form/group";
import UBXFormText from "./../ubx/form/input";
import UBXFormSelect from "./../ubx/form/select";
import UBXFormDate from "./../ubx/form/date";

import {
    ApplicationNameSuffixOptions,
    ApplicationGenderOptions,
} from "./../../const/application";

import { getConfig } from "./../../api/config";
import { ekycInitiate, getEKYCLink, updateEKYCProfile } from "./../../api/ekyc";

import { EKYCRetry } from "./../../config/ekyc";

import "./../../assets/css/containers/ekyc.css";

import RedirectImage from "./../../assets/imgs/bg/loader.gif";

export default class EKYCModal extends Component {
    _mounted = false;

    constructor(props) {
        super(props);

        this.state = {
            validIdsLoaded: false,
            validIds: {},
            status: false, // start, select, selected, generatingLink
            idType: false,
            links: false,
            checkCompletion: false,
            error: false,
            ekycDetails: {},
            initialDetails: {},
            errorFields: {},
            errorMessage: "",
            isBusy: false,
        };
    }

    async getValidIds() {
        let validIds = false;
        try {
            const rawValidIds = await getConfig("ekyc_ids");

            if (rawValidIds) {
                validIds = rawValidIds;
            }
        } catch (e) {
            console.error({ e });
        }

        return validIds;
    }

    async generateLink(idType, retry = false) {
        let generateLinkResponse = false;

        try {
            const ekycInitiateResponse = await ekycInitiate({ "document_id": parseInt(idType), retry });

            if (ekycInitiateResponse) {
                const { status, data } = ekycInitiateResponse;

                if (status !== 200) {
                    throw ekycInitiateResponse;
                }

                generateLinkResponse = data;
            }
        } catch (e) {
            await this.setState({ error: true });
        }

        return generateLinkResponse;
    }

    componentDidMount() {
        this._mounted = true;

        this.loadValidIds();
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    componentDidUpdate() {
        const { status } = this.state;

        switch (status) {
            case "selected": {
                this.onSelect();
                break;
            }
            default:
                break;
        }
    }

    initialize() {
        let { status: ekycResponse = false } = this.props;
        const { status = false, result = false, id_info: idInfo = {} } = ekycResponse || false;

        console.log(ekycResponse);
        let ekycDetails = {};

        if(idInfo && Object.keys(idInfo).length) {
            const { 
                first_name: firstName,
                last_name: lastName,
                middle_name: middleName,
                gender,
                birthdate,
            } = idInfo;

            ekycDetails = {
                "ekyc-first-name": firstName,
                "ekyc-last-name": lastName,
                "ekyc-middle-name": middleName,
                "ekyc-birthdate": birthdate?.replace(/\//gm, "-"),
                "ekyc-gender": gender === "F" ? "female" : "male"
            };
        }

        let ekycStatus = ekycResponse ? `${status}_${result}`.toLowerCase() : "start";

        if (ekycStatus === "pending_pending") {
            this.getLink();
        }

        this.setState({
            status: ekycStatus,
            idType: "",
            links: false,
            checkCompletion: false,
            ekycDetails,
            initialDetails: JSON.stringify(ekycDetails),
        });
    }

    async getLink() {
        try {
            const response = await getEKYCLink();

            if (response) {
                const { url, qr_code: qrCode } = response;

                await this.setState({ links: { url, qrCode }, status: "generatedLink" });

                window.setTimeout((e) => this.checkCompletion(e), 10000);
            }
        } catch (e) {
            const { response: { status } } = e;
            
            if (status === 400) {
                await this.setState({ error: true, status: "generatedLink" });
            } else {
                await this.setState({ error: true, status: "failed" });
            }
        }
    }

    async loadValidIds() {
        const validIds = await this.getValidIds();

        if (this._mounted) {
            await this.setState({ validIdsLoaded: true, validIds });
        }
    }

    onClose() {
        const { onClose = false } = this.props;

        if (onClose) {
            onClose();
        }
    }

    onStart(e) {
        e.preventDefault();

        this.setState({ status: "select" });
    }

    async onChange(name, value) {
        const { ekycDetails } = this.state;

        ekycDetails[name] = value;

        this.fuzzyMatch(name, value);

        this.setState({ ekycDetails });
    }

    fuzzyMatch(name, value) {
        const { initialDetails, errorFields } = this.state;
        const parsedDetails = JSON.parse(initialDetails);

        if(Fuzz.distance(parsedDetails[name], value) > 1) {
            errorFields[name] = "Does not match ID information";
        } else {
            errorFields[name] = "";
        }

        this.setState({ errorFields });
    }

    onSelectId(e) {
        e.preventDefault();

        let { target } = e;

        if (target.nodeName !== "BUTTON") {
            target = target.closest("button");
        }

        const { value } = target;

        this.setState({ status: "selected", idType: value });
    }

    async onSelect() {
        const { idType } = this.state;

        await this.setState({ status: "generatingLink" });

        let retries = parseInt(Cookies.load(EKYCRetry)) || 0;

        const linkGenerated = await this.generateLink(idType, retries > 0);

        if (linkGenerated === false) {
            this.setState({ status: "failed" });
        } else {
            const { url, qr_code: qrCode } = linkGenerated;

            retries++;

            await this.setState({ status: "generatedLink", links: { url, qrCode } });

            Cookies.save(EKYCRetry, retries, { path: "/" });

            if (isMobile) {
                this.onRedirect();
            }

            window.setTimeout((e) => this.checkCompletion(e), 10000);
        }
    }

    onRedirect() {
        window.setTimeout((e) => this.doRedirect(e), 3000);
    }

    doRedirect() {
        const { onRedirect = false } = this.props;
        const { links } = this.state;

        if (links !== false) {
            const { url } = links;

            if (onRedirect) {
                onRedirect(url);
            }
        }
    }

    checkCompletion() {
        this.setState({ checkCompletion: true });
    }

    checkStatus() {
        window.location.reload();
    }

    async onSyncProfile() {
        const { ekycDetails } = this.state;

        this.setState({ isBusy: true });
        const payload = {
            "given_name": ekycDetails["ekyc-first-name"].toUpperCase(),
            "middle_name": ekycDetails["ekyc-middle-name"].toUpperCase(),
            "family_name": ekycDetails["ekyc-last-name"].toUpperCase(),
            "birthdate": ekycDetails["ekyc-birthdate"],
            "gender": ekycDetails["ekyc-gender"]
        };

        Object.keys(payload).forEach(key => !payload[key] && delete payload[key]);

        try {
            const response = await updateEKYCProfile(payload);

            if (response) {
                this.setState({ status: "verified_passed", isBusy: false });
            }
        } catch (err) {
            this.setState({ errorMessage: "Something went wrong.", isBusy: false });
        }
    }

    onRetry() {
        let { status } = this.props;

        if (!status || status === "PENDING") {
            status = "start";
        }

        this.setState({ status, error: false });
    }

    renderContent() {
        const { 
            status,
            validIdsLoaded,
            validIds,
            links,
            checkCompletion,
            ekycDetails,
            errorFields,
            errorMessage,
            isBusy,
        } = this.state;

        let renderedContent = "";
        switch (status) {
            case "start": {
                renderedContent = (
                    <Fragment>
                        <Modal.Header closeButton closeLabel="Close e-KYC Modal">
                            <h2>Identity Verification</h2>
                        </Modal.Header>
                        <Modal.Body>
                            <p>
                                Prepare a valid ID and make sure that you are selfie-ready. This will only take a few minutes.
                            </p>
                        </Modal.Body>
                        <Modal.Footer>
                            <UBXButton type="primary" block={true} onClick={(e) => this.onStart(e)}>
                                Get Verified
                            </UBXButton>
                        </Modal.Footer>
                    </Fragment>
                );
                break;
            }
            case "select": {
                const idOptions = validIdsLoaded ? (
                    <div className="id-options">
                        {Object.keys(validIds).map((id) => {
                            return (
                                <UBXButton
                                    key={id}
                                    type="option-item"
                                    block={true}
                                    icon-right="arrow-blue"
                                    value={id}
                                    onClick={(e) => this.onSelectId(e)}
                                >
                                    <strong>{validIds[id]}</strong>
                                </UBXButton>
                            );
                        })}
                    </div>
                ) : (
                    <span className="not-available">No IDs available</span>
                );

                renderedContent = (
                    <Fragment>
                        <Modal.Header closeButton closeLabel="Close e-KYC Modal">
                            <h2>Select a Valid ID</h2>
                        </Modal.Header>
                        <Modal.Body>
                            <h3>Valid ID</h3>
                            <p>Ensure that you have your authentic and updated valid ID ready.</p>
                            {idOptions}
                        </Modal.Body>
                    </Fragment>
                );
                break;
            }
            case "selected":
            case "generatingLink": {
                renderedContent = (
                    <Fragment>
                        <Modal.Header closeButton closeLabel="Close e-KYC Modal">
                            <h2>Please wait...</h2>
                        </Modal.Header>
                        <Modal.Body>
                            <h3>Please wait while we are starting the verification.</h3>
                        </Modal.Body>
                    </Fragment>
                );
                break;
            }
            case "generatedLink": {
                if (links !== false) {
                    const { qrCode } = links;

                    let completionNotice = "";
                    if (checkCompletion) {
                        completionNotice = (
                            <p>
                                <hr />
                                Did you complete your e-KYC verification?
                                <UBXButton type="primary" block={true} onClick={(e) => this.checkStatus(e)}>
                                    Check here
                                </UBXButton>
                            </p>
                        );
                    }

                    if (isMobile) {
                        renderedContent = (
                            <Fragment>
                                <Modal.Header closeButton closeLabel="Close e-KYC Modal">
                                    <h2>Please wait while we redirect you to eKYC</h2>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>
                                        <img src={RedirectImage} alt="Redirecting..." height="220" width="auto" />
                                        <br />
                                        <br />
                                        <br />
                                        If you are not redirected automatically,
                                        <UBXButton type="link" block={true} onClick={(e) => this.doRedirect(e)}>
                                            Click here
                                        </UBXButton>
                                    </p>
                                    {completionNotice}
                                </Modal.Body>
                            </Fragment>
                        );
                    } else {
                        renderedContent = (
                            <Fragment>
                                <Modal.Header closeButton closeLabel="Close e-KYC Modal">
                                    <h2>Scan QR</h2>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>
                                        <img src={qrCode} alt="e-KYC QR Code" />
                                        <br />
                                        To continue with the verification, scan the QR code above using your mobile phone.
                                    </p>
                                    {completionNotice}
                                </Modal.Body>
                            </Fragment>
                        );
                    }
                } else {
                    renderedContent = (
                        <Fragment>
                            <Modal.Header closeButton closeLabel="Close e-KYC Modal">
                                <h2>Ongoing identity verification</h2>
                            </Modal.Header>
                            <Modal.Body className="pending">
                                <p>Your ID is still under ongoing verification. If you wish to try again, press the button below.</p>
                            </Modal.Body>
                            <Modal.Footer>
                                <UBXButton type="link" onClick={(e) => this.onClose(e)}>
                                    Maybe later
                                </UBXButton>
                                &nbsp;&nbsp;&nbsp;
                                <UBXButton type="primary" onClick={(e) => this.onRetry(e)}>
                                    Try Again
                                </UBXButton>
                            </Modal.Footer>
                        </Fragment>
                    );
                }
                break;
            }
            case "pending": {
                renderedContent = (
                    <Fragment>
                        <Modal.Header closeButton closeLabel="Close e-KYC Modal">
                            <h2>Ongoing identity verification</h2>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Your ID is still under ongoing verification. Please check this page again in a while.</p>
                        </Modal.Body>
                    </Fragment>
                );
                break;
            }
            case "completed_passed": {
                const disableButton = Object.values(errorFields).every(errField => errField === "");

                renderedContent = (
                    <Fragment>
                        <Modal.Header closeButton closeLabel="Close e-KYC Modal">
                            <h2>Verification Successful</h2>
                        </Modal.Header>
                        <Modal.Body>
                            <Fragment>
                                <div className="field-row">
                                    <UBXFormGroup size={[6, 6]} title="Full name">
                                        <UBXFormText
                                            type="text"
                                            name="ekyc-first-name"
                                            label="First Name"
                                            required={true}
                                            value={ekycDetails["ekyc-first-name"]}
                                            onChange={(name, value) => this.onChange(name, value)}
                                            error={errorFields["ekyc-first-name"]}
                                        />
                                        <UBXFormText
                                            type="text"
                                            name="ekyc-last-name"
                                            label="Last Name"
                                            required={true}
                                            value={ekycDetails["ekyc-last-name"]}
                                            onChange={(name, value) => this.onChange(name, value)}
                                            error={errorFields["ekyc-last-name"]}
                                        />
                                    </UBXFormGroup>
                                    <UBXFormGroup size={[6, 6]}>
                                        <UBXFormText
                                            type="text"
                                            name="ekyc-middle-name"
                                            label="Middle Name"
                                            value={ekycDetails["ekyc-middle-name"]}
                                            onChange={(name, value) => this.onChange(name, value)}
                                            error={errorFields["ekyc-middle-name"]}
                                            readonly={!ekycDetails["ekyc-middle-name"]}
                                        />
                                        <UBXFormSelect
                                            name="ekyc-suffix"
                                            label="Suffix"
                                            placeholder="None"
                                            required={false}
                                            options={ApplicationNameSuffixOptions}
                                            value={ekycDetails["ekyc-suffix"]}
                                            onChange={(name, value) => this.onChange(name, value)}
                                            error={errorFields["ekyc-suffix"]}
                                            readonly={!ekycDetails["ekyc-suffix"]}
                                        />
                                    </UBXFormGroup>
                                </div>
                                <div className="field-row">
                                    <UBXFormDate
                                        type="birthday"
                                        name="ekyc-birthdate"
                                        label="Date of birth"
                                        required={true}
                                        value={ekycDetails["ekyc-birthdate"]}
                                        onChange={(name, value) => this.onChange(name, value)}
                                        readonly={true}
                                    />
                                </div>
                                <div className="field-row">
                                    <UBXFormSelect
                                        type="pill"
                                        name="ekyc-gender"
                                        label="Gender"
                                        options={ApplicationGenderOptions}
                                        required={true}
                                        value={ekycDetails["ekyc-gender"]}
                                        onChange={(name, value) => this.onChange(name, value)}
                                    />
                                </div>
                            </Fragment>
                            <p>Please verify, if the details from your ID is correct</p>
                            <UBXButton
                                type="primary"
                                block={true}
                                onClick={(e) => this.onSyncProfile(e)}
                                disabled={!disableButton || isBusy}
                            >
                                Verify
                            </UBXButton>
                            {
                                errorMessage && <p className="error">{errorMessage}</p>
                            }
                            <p>
                                Not the details in your ID? <a href={"mailto:support@seekcap.ph"}>Contact us</a>
                            </p>
                        </Modal.Body>
                    </Fragment>
                );
                break;
            }
            case "verified_passed": {
                renderedContent = (
                    <Fragment>
                        <Modal.Header closeButton closeLabel="Close e-KYC Modal">
                            <h2>Verification successful</h2>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Congratulations! Your identity has been verified. You can now apply for a loan</p>
                            <UBXButton
                                type="primary"
                                block={true}
                                onClick={() => 
                                {
                                    this.onClose();
                                    window.location.reload();
                                }
                                }>
                                Continue
                            </UBXButton>
                        </Modal.Body>
                    </Fragment>
                );
                break;
            }
            case "failed": {
                renderedContent = (
                    <Fragment>
                        <Modal.Header closeButton closeLabel="Close e-KYC Modal">
                            <h2>
                                We are encountering an error. <br />
                                Please try again later.
                            </h2>
                        </Modal.Header>
                        <Modal.Body>
                            <p>There has been an error on your ID verification. Press the button below to try again</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <UBXButton type="link" onClick={(e) => this.onClose(e)}>
                                Maybe later
                            </UBXButton>
                            &nbsp;&nbsp;&nbsp;
                            <UBXButton type="primary" onClick={(e) => this.onRetry(e)}>
                                Try Again
                            </UBXButton>
                        </Modal.Footer>
                    </Fragment>
                );
                break;
            }
            default: {
                break;
            }
        }

        return renderedContent;
    }

    render() {
        const { status /*, error*/ } = this.state;
        const { show = false } = this.props;

        return (
            <Modal
                id="ekyc-modal"
                contentClassName={`ekyc-verify ${status}`}
                dialogClassName={isMobile && "isMobile"}
                show={show}
                backdrop="static"
                centered={isMobile ? false : true}
                onShow={() => this.initialize()}
                onHide={() => this.onClose()}
            >
                {this.renderContent()}
            </Modal>
        );
    }
}
